import slick from 'slick-carousel';
import magnific from './mangnific-popup';